/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType, BodyType } from '../../../customInstance'
import type {
    GetRequestJobsPermissionsByJobUuidParams,
    GetRequestJobsPrivacyModeByJobUuidParams,
    HTTPValidationErrorDTO,
    JobPermissionsResponseDTO,
    JobPrivacyModeResponseDTO,
    JobSetPermissionsResponseDTO,
    PostRequestJobsExpirationDateByJobUuidParams,
    PostRequestJobsPasswordByJobUuidParams,
    PostRequestJobsPermissionsByJobUuidParams,
    PostRequestJobsPrivacyModeByJobUuidParams,
    PostRequestJobsRecipientsByJobUuidParams,
    PostRequestJobsStorePasswordByJobUuidParams,
    RecipientListDTO,
    SetJobRecipientResponseDTO,
    ShareExpirationDTO,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * Change the privacy mode of a story job.
The underlying implementation manipulates the three flags
allow_sharing, allow_anonymous_access and allow_discovery
to conform to the privacy mode.
Optionally, if the privacy mode is set to either protected or shared,
a timestamp may be provided to specify the
expiration date of the sharing. This can also be used to update the
expiration date on a share, by providing the same privacy mode and
an updated expiration timestamp. If private mode is provided, the
expiration will always be removed.

 * @summary Set Privacy Mode
 */
export const postRequestJobsPrivacyModeByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsPrivacyModeByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<JobSetPermissionsResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/privacy_mode`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsPrivacyModeByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsPrivacyModeByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsPrivacyModeByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsPrivacyModeByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPrivacyModeByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsPrivacyModeByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsPrivacyModeByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsPrivacyModeByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsPrivacyModeByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsPrivacyModeByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsPrivacyModeByJobUuid>>
>

export type PostRequestJobsPrivacyModeByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Set Privacy Mode
 */
export const usePostRequestJobsPrivacyModeByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsPrivacyModeByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsPrivacyModeByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsPrivacyModeByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPrivacyModeByJobUuidParams },
    TContext
> => {
    const mutationOptions = getPostRequestJobsPrivacyModeByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get the current privacy mode of a story job.

 * @summary Get Privacy Mode
 */
export const getRequestJobsPrivacyModeByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsPrivacyModeByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<JobPrivacyModeResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/privacy_mode`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsPrivacyModeByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsPrivacyModeByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/privacy_mode`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsPrivacyModeByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPrivacyModeByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestJobsPrivacyModeByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>
    > = ({ signal }) => getRequestJobsPrivacyModeByJobUuid(jobUuid, params, requestOptions, signal)

    return { queryKey, queryFn, enabled: !!jobUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsPrivacyModeByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>
>
export type GetRequestJobsPrivacyModeByJobUuidQueryError = ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsPrivacyModeByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPrivacyModeByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsPrivacyModeByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPrivacyModeByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsPrivacyModeByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPrivacyModeByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Privacy Mode
 */

export function useGetRequestJobsPrivacyModeByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPrivacyModeByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPrivacyModeByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsPrivacyModeByJobUuidQueryOptions(jobUuid, params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Change the permission settings on a story job. At least one permission
setting is needed. Any unspecified settings is left unchanged

 * @summary Set Permissions
 */
export const postRequestJobsPermissionsByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsPermissionsByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<JobSetPermissionsResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/permissions`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsPermissionsByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsPermissionsByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsPermissionsByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsPermissionsByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPermissionsByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsPermissionsByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsPermissionsByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsPermissionsByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsPermissionsByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsPermissionsByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsPermissionsByJobUuid>>
>

export type PostRequestJobsPermissionsByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Set Permissions
 */
export const usePostRequestJobsPermissionsByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsPermissionsByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsPermissionsByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsPermissionsByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPermissionsByJobUuidParams },
    TContext
> => {
    const mutationOptions = getPostRequestJobsPermissionsByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Get the current permission settings of a story job.

 * @summary Get Permissions
 */
export const getRequestJobsPermissionsByJobUuid = (
    jobUuid: string,
    params: GetRequestJobsPermissionsByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<JobPermissionsResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/permissions`,
            method: 'GET',
            params,
            signal,
        },
        options,
    )
}

export const getGetRequestJobsPermissionsByJobUuidQueryKey = (
    jobUuid?: string,
    params?: GetRequestJobsPermissionsByJobUuidParams,
) => {
    return [`/jobs/${jobUuid}/permissions`, ...(params ? [params] : [])] as const
}

export const getGetRequestJobsPermissionsByJobUuidQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPermissionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey =
        queryOptions?.queryKey ?? getGetRequestJobsPermissionsByJobUuidQueryKey(jobUuid, params)

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>
    > = ({ signal }) => getRequestJobsPermissionsByJobUuid(jobUuid, params, requestOptions, signal)

    return { queryKey, queryFn, enabled: !!jobUuid, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestJobsPermissionsByJobUuidQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>
>
export type GetRequestJobsPermissionsByJobUuidQueryError = ErrorType<void | HTTPValidationErrorDTO>

export function useGetRequestJobsPermissionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPermissionsByJobUuidParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsPermissionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPermissionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestJobsPermissionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPermissionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Permissions
 */

export function useGetRequestJobsPermissionsByJobUuid<
    TData = Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
    TError = ErrorType<void | HTTPValidationErrorDTO>,
>(
    jobUuid: string,
    params: GetRequestJobsPermissionsByJobUuidParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getRequestJobsPermissionsByJobUuid>>,
                TError,
                TData
            >
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestJobsPermissionsByJobUuidQueryOptions(jobUuid, params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * Set the allowed recipients of a shared job.
The users can be provided by the recipients user_id or with an msisdn or email
associated with the recipients TelenorID account.
If an msisdn or email not associated with a TelenorID account is provided, a temporary link is created
which can be used by the recipient when a TelenorID account is created and the share is accessed.

 * @summary Post Recipients
 */
export const postRequestJobsRecipientsByJobUuid = (
    jobUuid: string,
    recipientListDTO: BodyType<RecipientListDTO>,
    params: PostRequestJobsRecipientsByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<SetJobRecipientResponseDTO>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/recipients`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: recipientListDTO,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsRecipientsByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsRecipientsByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<RecipientListDTO>
            params: PostRequestJobsRecipientsByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsRecipientsByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<RecipientListDTO>
        params: PostRequestJobsRecipientsByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsRecipientsByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsRecipientsByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<RecipientListDTO>
            params: PostRequestJobsRecipientsByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsRecipientsByJobUuid(jobUuid, data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsRecipientsByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsRecipientsByJobUuid>>
>
export type PostRequestJobsRecipientsByJobUuidMutationBody = BodyType<RecipientListDTO>
export type PostRequestJobsRecipientsByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Recipients
 */
export const usePostRequestJobsRecipientsByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsRecipientsByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<RecipientListDTO>
                params: PostRequestJobsRecipientsByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsRecipientsByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<RecipientListDTO>
        params: PostRequestJobsRecipientsByJobUuidParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestJobsRecipientsByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * Set the expiration date of a shared job.
This overrides the default share lifetime of 30 days

 * @summary Post Job Expiration
 */
export const postRequestJobsExpirationDateByJobUuid = (
    jobUuid: string,
    shareExpirationDTO: BodyType<ShareExpirationDTO>,
    params: PostRequestJobsExpirationDateByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/expiration_date`,
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            data: shareExpirationDTO,
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsExpirationDateByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsExpirationDateByJobUuid>>,
        TError,
        {
            jobUuid: string
            data: BodyType<ShareExpirationDTO>
            params: PostRequestJobsExpirationDateByJobUuidParams
        },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsExpirationDateByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<ShareExpirationDTO>
        params: PostRequestJobsExpirationDateByJobUuidParams
    },
    TContext
> => {
    const mutationKey = ['postRequestJobsExpirationDateByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsExpirationDateByJobUuid>>,
        {
            jobUuid: string
            data: BodyType<ShareExpirationDTO>
            params: PostRequestJobsExpirationDateByJobUuidParams
        }
    > = (props) => {
        const { jobUuid, data, params } = props ?? {}

        return postRequestJobsExpirationDateByJobUuid(jobUuid, data, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsExpirationDateByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsExpirationDateByJobUuid>>
>
export type PostRequestJobsExpirationDateByJobUuidMutationBody = BodyType<ShareExpirationDTO>
export type PostRequestJobsExpirationDateByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Job Expiration
 */
export const usePostRequestJobsExpirationDateByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsExpirationDateByJobUuid>>,
            TError,
            {
                jobUuid: string
                data: BodyType<ShareExpirationDTO>
                params: PostRequestJobsExpirationDateByJobUuidParams
            },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsExpirationDateByJobUuid>>,
    TError,
    {
        jobUuid: string
        data: BodyType<ShareExpirationDTO>
        params: PostRequestJobsExpirationDateByJobUuidParams
    },
    TContext
> => {
    const mutationOptions = getPostRequestJobsExpirationDateByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to change the password for a story job.

 * @summary Post Job Password
 */
export const postRequestJobsPasswordByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsPasswordByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/password`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsPasswordByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsPasswordByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsPasswordByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsPasswordByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPasswordByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsPasswordByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsPasswordByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsPasswordByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsPasswordByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsPasswordByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsPasswordByJobUuid>>
>

export type PostRequestJobsPasswordByJobUuidMutationError = ErrorType<void | HTTPValidationErrorDTO>

/**
 * @summary Post Job Password
 */
export const usePostRequestJobsPasswordByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsPasswordByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsPasswordByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsPasswordByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsPasswordByJobUuidParams },
    TContext
> => {
    const mutationOptions = getPostRequestJobsPasswordByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call is used to update the password for a user to a story

 * @deprecated
 * @summary Post Job Store Password
 */
export const postRequestJobsStorePasswordByJobUuid = (
    jobUuid: string,
    params: PostRequestJobsStorePasswordByJobUuidParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<unknown>(
        {
            url: `/jobs/${encodeURIComponent(String(jobUuid))}/store-password`,
            method: 'POST',
            params,
            signal,
        },
        options,
    )
}

export const getPostRequestJobsStorePasswordByJobUuidMutationOptions = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postRequestJobsStorePasswordByJobUuid>>,
        TError,
        { jobUuid: string; params: PostRequestJobsStorePasswordByJobUuidParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof postRequestJobsStorePasswordByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsStorePasswordByJobUuidParams },
    TContext
> => {
    const mutationKey = ['postRequestJobsStorePasswordByJobUuid']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postRequestJobsStorePasswordByJobUuid>>,
        { jobUuid: string; params: PostRequestJobsStorePasswordByJobUuidParams }
    > = (props) => {
        const { jobUuid, params } = props ?? {}

        return postRequestJobsStorePasswordByJobUuid(jobUuid, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PostRequestJobsStorePasswordByJobUuidMutationResult = NonNullable<
    Awaited<ReturnType<typeof postRequestJobsStorePasswordByJobUuid>>
>

export type PostRequestJobsStorePasswordByJobUuidMutationError =
    ErrorType<void | HTTPValidationErrorDTO>

/**
 * @deprecated
 * @summary Post Job Store Password
 */
export const usePostRequestJobsStorePasswordByJobUuid = <
    TError = ErrorType<void | HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postRequestJobsStorePasswordByJobUuid>>,
            TError,
            { jobUuid: string; params: PostRequestJobsStorePasswordByJobUuidParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof postRequestJobsStorePasswordByJobUuid>>,
    TError,
    { jobUuid: string; params: PostRequestJobsStorePasswordByJobUuidParams },
    TContext
> => {
    const mutationOptions = getPostRequestJobsStorePasswordByJobUuidMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
